const mm = 10 // pixels per millimeter
let dimensions = 68.8;

const device = document.body.querySelector('.device') as HTMLElement
const canvas = document.createElement('canvas')
const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
device.style.width = (dimensions * 1.25 + 16) + 'mm'
device.style.height = (dimensions * 1.25 + 16) + 'mm'
canvas.style.width = dimensions + 'mm'
canvas.style.height = dimensions + 'mm'
canvas.width = dimensions * mm
canvas.height = dimensions * mm
device.append(canvas)
canvas.classList.add('speaker')

const p = document.createElement('p')
document.body.append(p)

ctx.fillStyle = `#222`

const form = document.getElementById('form')

if (form) {
  const input = form.querySelector('#dimension') as HTMLInputElement

  form.querySelector('#submit-in')?.addEventListener('click', () => {
    const sidein = parseFloat(input.value)
    setDimensions(sidein * 25.4)
  })

  form.querySelector('#submit-cm')?.addEventListener('click', () => {
    const sidecm = parseFloat(input.value)
    setDimensions(sidecm * 10)
  })

  form.querySelector('#submit-cm2')?.addEventListener('click', () => {
    const surfacecm = parseFloat(input.value)
    setDimensions(Math.sqrt(surfacecm / Math.PI) * 2 * 10)
  })
}

setDimensions(dimensions)

function setDimensions (sizeInMm: number) {
  console.log(sizeInMm + ' mm')

  if (form) (form.querySelector('#value') as HTMLParagraphElement).textContent = `Membrane emissive surface : ${Math.round(Math.PI * (sizeInMm / 10 / 2) ** 2 * 100) / 100} cm²`

  dimensions = sizeInMm
  device.style.width = (dimensions * 1.25 + 16) + 'mm'
  device.style.height = (dimensions * 1.25 + 16) + 'mm'
  canvas.style.width = dimensions + 'mm'
  canvas.style.height = dimensions + 'mm'
  canvas.width = dimensions * mm
  canvas.height = dimensions * mm
  
  generate()
}

function generateHolesInCircle (_rows, _base) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  let circles = [1]
  const u = _base
  for (let a = 1; a < _rows; a++) {
    circles.push(a * u)
  }

  // const circles = [1, 6, 12, 20, 24, 32, 36]
  // const circles = [1, 8, 16, 24, 32, 40]
  // const circles = [1, 6, 9, 12, 15, 18]
  // const circles = [1, 6, 10, 15, 24, 33, 40]
  // const circles = [2, 3, 5, 7, 11, 13, 17, 19] // prime numbers
  // let circles = [1]
  // const j = 7
  // for (let a = 0; a < 6; a++) {
  //   circles.push(Math.floor((circles[a] + Math.random() * 10) / j) * j)
  // }

  const holesTotalArea = Math.PI * Math.pow((dimensions / 2), 2) * 0.25 // 25% air
  const numberOfHoles = circles.reduce((acc, val) => acc + val)
  const holeArea = holesTotalArea / numberOfHoles
  const holeRadius = Math.round(Math.sqrt(holeArea / Math.PI) * 4) / 4
  const holeDiameter = holeRadius * 2

  p.innerHTML = `${numberOfHoles} trous<br/>⌀ ${holeDiameter} mm<br/>${Math.round(100 * (numberOfHoles * Math.PI * holeRadius ** 2) / (Math.PI * (dimensions / 2) ** 2))}% air`

  circles.forEach((n, r) => {
    const radius = r / (circles.length - 1) * ((dimensions / 2) * mm - holeRadius * mm)

    // ctx.fillStyle = `hsl(${Math.random() * 360}, 100%, 50%)`
    for (let i = 0; i < n; i++) {
      let x = Math.sin((i / n) * Math.PI * 2) * radius + (dimensions / 2) * mm
      let y = Math.cos((i / n) * Math.PI * 2) * radius + (dimensions / 2) * mm

      ctx.beginPath()
      ctx.ellipse(x, y, holeRadius * mm, holeRadius * mm, 0, 0, Math.PI * 2)
      ctx.fill()
    }
  })
}

function generateHolesGrid (_side) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  const positions = [] as any

  for (let y = 0; y < _side; y++) {
    for (let x = 0; x < _side; x++) {
      const pos = {
        x: (x + 0.5) * dimensions / _side,
        y: (y + 0.5) * dimensions / _side
      }

      // const isInsideCircle = true
      const isInsideCircle = Math.sqrt((pos.x - (dimensions / 2)) ** 2 + (pos.y - (dimensions / 2)) ** 2) < dimensions / 2
      // const isInsideCircle = (pos.x - (dimensions / 2)) ** 2 + (pos.y - (dimensions / 2)) ** 2 < dimensions * mm

      if (isInsideCircle) positions.push(pos)
    }
  }

  const holesTotalArea = Math.PI * Math.pow(dimensions / 2, 2) * 0.25 // 25% air
  const numberOfHoles = positions.length
  const holeArea = holesTotalArea / numberOfHoles
  const holeRadius = Math.round(Math.sqrt(holeArea / Math.PI) * 4) / 4
  const holeDiameter = holeRadius * 2

  p.innerHTML = `${numberOfHoles} trous<br/>⌀ ${holeDiameter} mm<br/>${Math.round(100 * (numberOfHoles * Math.PI * holeRadius ** 2) / (Math.PI * (dimensions / 2) ** 2))}% air`

  positions.forEach(({x, y}) => {
    ctx.beginPath()
    ctx.ellipse(x * mm, y * mm, holeRadius * mm, holeRadius * mm, 0, 0, Math.PI * 2)
    ctx.fill()
  })
}

function generate () {
  if (Math.random() > 0.5) {
    const rows = Math.floor(Math.random() * 6 + 6)
    const base = Math.floor(Math.random() * 6 + 4)
    generateHolesInCircle(rows, base)
  } else {
    const side = Math.floor(Math.random() * 20 + 5)
    generateHolesGrid(side)
  }
}

generate()
